import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Icon, Button } from 'antd';
import DropzoneS3Uploader from 'react-dropzone-s3-uploader';

import { REACT_APP_ENDPOINT } from 'config/env';
import { getPrivateDownloadUrl, getUploadSigningHeaders } from 'utils/apis/s3';

import styles from './UploadFile.module.css';

const uploadOptions = {
  server: REACT_APP_ENDPOINT,
  signingUrlQueryParams: { uploadType: 'avatar' },
  signingUrlHeaders: {},
  // Bucket has ACLs disabled (bucket owner enforced); do not send x-amz-acl.
  uploadRequestHeaders: {}
};

const buildPrivateUploadOptions = privateType => ({
  ...uploadOptions,
  signingUrl: `/s3/private/${privateType}/sign`,
  signingUrlQueryParams: { uploadType: privateType }
});

// The stored URL is returned by the backend (info.fileUrl). s3Url is unused for
// the result but the uploader library requires the prop to be a string.
const s3Url = '';

const openPrivateFile = file => async e => {
  e.preventDefault();
  const win = window.open('', '_blank');
  const url = await getPrivateDownloadUrl(file.key || file.name);
  if (url) {
    if (win) win.location = url;
    else window.location = url;
  } else if (win) {
    win.close();
  }
};

const FileLink = ({ file, isPrivate }) => {
  if (isPrivate && file.key) {
    return (
      <a href={file.link || '#'} onClick={openPrivateFile(file)} target="_blank" rel="noopener noreferrer">
        {file.name}
      </a>
    );
  }
  return (
    <a href={file.link} target="_blank" rel="noopener noreferrer">
      {file.name}
    </a>
  );
};

class UploadFile extends React.Component {
  render() {
    const { file, buttonText, containerClassname, onUploadFinish, onFileDelete, isPrivate, privateType } = this.props;
    const upload = isPrivate ? { ...buildPrivateUploadOptions(privateType), signingUrlHeaders: getUploadSigningHeaders() } : uploadOptions;

    return (
      <Row type="flex" align="middle" className={containerClassname}>
        <div className={styles.uploadContainer}>
          <Col span={24} className={styles.fileContainer}>
            <p className={styles.fileIcon}>
              <Icon type="file-protect" />
            </p>
            <DropzoneS3Uploader onFinish={onUploadFinish} s3Url={s3Url} upload={upload} className={styles.uploadButton}>
              <Button className={styles.button}>
                <Icon type="upload" /> {buttonText}
              </Button>
            </DropzoneS3Uploader>
            <Col className={styles.fileList}>
              <FileLink file={file} isPrivate={isPrivate} />
              {Object.getOwnPropertyNames(file).length > 0 && (
                <span className={styles.delete}>
                  <Icon onClick={onFileDelete} type="close" />
                </span>
              )}
            </Col>
          </Col>
        </div>
      </Row>
    );
  }
}

FileLink.propTypes = {
  file: PropTypes.object.isRequired,
  isPrivate: PropTypes.bool
};

UploadFile.propTypes = {
  onUploadFinish: PropTypes.func.isRequired,
  containerClassname: PropTypes.string,
  file: PropTypes.object,
  isPrivate: PropTypes.bool,
  privateType: PropTypes.string
};

UploadFile.defaultProps = {
  containerClassname: '',
  file: {},
  onUploadFinish: () => {},
  isPrivate: false,
  privateType: 'expenses'
};

export default UploadFile;
